import { id } from "../../node_modules/postcss-selector-parser";

/* 信息返回对象 */
class ResultData {
  constructor ({
    message = '',
    result = false
  } = {}) {
    this.message = message
    this.result = result
  }
}
// 获取query某个值
let getQueryString = (name) => {
  try {
    var reg = new RegExp('(\\\?|&)?' + name + '=((.*?)&|(.*))', 'i')
    let rr = window.location.hash.match(reg)
    return decodeURIComponent(rr[3]) || decodeURIComponent(rr[4])
  } catch (error) {}
}

let FormatDate = (time, format) => {
  var t = new Date(time)
  var tf = function (i) {
    return (i < 10 ? '0' : '') + i
  }
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear())
      case 'MM':
        return tf(t.getMonth() + 1)
      case 'mm':
        return tf(t.getMinutes())
      case 'dd':
        return tf(t.getDate())
      case 'HH':
        return tf(t.getHours())
      case 'ss':
        return tf(t.getSeconds())
    }
  })
}

/**
 * @description 对象的map函数
 *
 * @param {*} obj 要遍历的对象
 * @param {*} cb 回调
 * @returns 回调之后的数组集合
 */
let mapObj = (obj, cb) => {
  let tmp = []
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      tmp.push(cb(obj[key]))
    }
  }
  return tmp
}

/**
 * 手机号校验
 *
 * @param {*} mobile 要校验的手机号码
 * @returns ResultData 对象
 */
const validatemobile = function (mobile) {
  if (mobile.length === 0) {
    return new ResultData({
      message: '手机号长度不能为空',
      result: false
    })
  }
  if (mobile.length !== 11) {
    return new ResultData({
      message: '手机号长度不正确',
      result: false
    })
  }

  var myreg = /^1[0-9]{10}$/
  if (!myreg.test(mobile)) {
    return new ResultData({
      message: '手机号不正确',
      result: false
    })
  }
  // 默认返回值
  return new ResultData({
    message: '',
    result: true
  })
}
/**
 * @description 身份证号码校验
 *
 * @param {*} idcard 要检验的身份证号
 * @returns ResultData
 */
const IdentityCodeValid = function (idcard) {
  let area = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外'
  }

  let ereg, Y, JYM
  let S, M
  let idCardArray = idcard.split('')
  // 地区检验
  if (area[parseInt(idcard.substr(0, 2))] == null) {
    return new ResultData({
      message: '身份证地区非法!',
      result: false
    })
  }
  // 身份号码位数及格式检验
  switch (idcard.length) {
    // 15位身份号码检测
    case 15:
      if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 || ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)) {
        ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/ // 测试出生日期的合法性
      } else {
        ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/ // 测试出生日期的合法性
      }
      if (ereg.test(idcard)) {
        return new ResultData({
          message: '验证通过!',
          result: true
        })
      } else {
        return new ResultData({
          message: '身份证号码校验错误!',
          result: false
        })
      }
      // 18位身份号码检测
    case 18:
      if (parseInt(idcard.substr(6, 4)) % 4 == 0 || (parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0)) {
        ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/ // 闰年出生日期的合法性正则表达式
      } else {
        ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/ // 平年出生日期的合法性正则表达式
      }
      if (ereg.test(idcard)) { // 测试出生日期的合法性
        // 计算校验位
        S = (parseInt(idCardArray[0]) + parseInt(idCardArray[10])) * 7 +
          (parseInt(idCardArray[1]) + parseInt(idCardArray[11])) * 9 +
          (parseInt(idCardArray[2]) + parseInt(idCardArray[12])) * 10 +
          (parseInt(idCardArray[3]) + parseInt(idCardArray[13])) * 5 +
          (parseInt(idCardArray[4]) + parseInt(idCardArray[14])) * 8 +
          (parseInt(idCardArray[5]) + parseInt(idCardArray[15])) * 4 +
          (parseInt(idCardArray[6]) + parseInt(idCardArray[16])) * 2 +
          parseInt(idCardArray[7]) * 1 +
          parseInt(idCardArray[8]) * 6 +
          parseInt(idCardArray[9]) * 3
        Y = S % 11
        M = 'F'
        JYM = '10X98765432'
        M = JYM.substr(Y, 1) // 判断校验位
        if (M === idCardArray[17]) {
          return new ResultData({
            message: '验证通过!',
            result: true
          }) // 检测ID的校验位
        } else {
          return new ResultData({
            message: '身份证号码校验错误!',
            result: false
          })
        }
      } else {
        return new ResultData({
          message: '身份证号码出生日期超出范围或含有非法字符!',
          result: false
        })
      }

    default:
      return new ResultData({
        message: '身份证号码位数不对!',
        result: false
      })
  }
}

let getUrlKey = function (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

/**
 * @description 根据key值 去除arr里 key值重复的子项
 * @example [{k:1,v:11},{k:1,v:22}]  ==> [{k:1,v:11}]
 * @param {Array} arr 需要去重的数据
 * @param {String} key key值
 * @returns
 */
const uniqueByKey = (arr, key) => {
  let res = new Map()
  arr = arr.filter(function (item) {
    return !res.has(item[key]) && res.set(item[key], '1')
  })
  return arr
}

/**
 * 拼接url 参数
 *
 * @param {*} url
 * @param {*} data
 * @returns
 */
const concatUrl = (url, data) => {
  // 匹配 是否 有参数 拼接 url
  let matchQuery = /[?|&](\w+)=(\w+)/ig
  if (matchQuery.test(url)) {
    url += '&'
  } else {
    url += '?'
  }
  // 拼接参数
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      url += `${key}=${data[key]}` + '&'
    }
  }
  url = url.substring(0, url.length - 1)
  return url
}

/**按某个属性排序 */
function compare(property){
  //降序
  return function(a,b){
      var value1 = a[property];
      var value2 = b[property];
      return value2 - value1;
  }
}
/**自动换行 */
function autoSplit(value,maxlength){
  var valueDetal = value.split("-").join("");
  var ret = ""; //拼接加\n返回的类目项
  var maxLength = maxlength?maxlength:4; //每项显示文字个数
  var valLength = valueDetal.length; //X轴类目项的文字个数
  // console.log(valLength);
  var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
  if (rowN > 1) { //如果类目项的文字大于3,
      for (var i = 0; i < rowN; i++) {
          var temp = ""; //每次截取的字符串
          var start = i * maxLength; //开始截取的位置
          var end = start + maxLength; //结束截取的位置
  //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
          temp = valueDetal.substring(start, end) + "\n";
          ret += temp; //凭借最终的字符串
      }
      return ret;
  } else {
      return valueDetal;
  }
}
//阿拉伯数字转换为简写汉字
let number2Chinese = (section)=> {
  var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
    var chnUnitChar = ["", "十", "百", "千"];
    var strIns = '', chnStr = '';
    var unitPos = 0;
    var zero = true;
    while (section > 0) {
        var v = section % 10;
        if (v === 0) {
            if (!zero) {
                zero = true;
                chnStr = chnNumChar[v] + chnStr;
            }
        } else {
            zero = false;
            strIns = chnNumChar[v];
            strIns += chnUnitChar[unitPos];
            chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
    }
    return chnStr;
}
//处理每周数据
let handelWeek = (num) => {
  switch (num) {
    case 0 :
      return '周日'
    case 1:
      return '周一';
    case 2:
      return '周二';
    case 3:
      return '周三';
    case 4:
      return '周四';
    case 5:
      return '周五';
    case 6:
      return '周六';
  }
}

/**
 * 类型检测
 *
 * @param {*} target 要检测的对象
 * @returns 对象类型的小写
 */
const type = target => {
  return Object.prototype.toString
    .call(target)
    .slice(8, -1)
    .toLowerCase();
};

/**获取文件类型 */
let getFileType =(filename)=>{
  let type =""
  let arr = filename.split('.')
  let h = arr[arr.length-1].toLowerCase();
      switch(h) {
          case 'doc' :
          case 'docx' :
              type="icon-word-"
              break;
          case 'xls' :
          case 'xlsx' :
              type="icon-excel-"
              break;
          case 'ppt' :
          case 'pptx' :
              type="icon-ppt-"
              break;
          case 'txt' :
              type="icon-txt-"
              break;
          case 'pdf' :
              type="icon-pdf-"
              break;
          case 'zip' :
          case 'rar' :
              type="icon-yasuobao-"
              break;  
          case 'jpg' :
              type="icon-jpg"
              break; 
          case 'png' :
              type="icon-png"
              break; 
          default:
              type="icon-qita--"
              break;
      }
  return type
}

/**获取文件大小 */
let getFileSize=(fileSize)=>{
  let temp = ''
  if (fileSize < 1024) {
      return fileSize + 'B';
  } else if (fileSize < (1024*1024)) {
      temp = (fileSize / 1024).toFixed(2);
      return temp + 'K';
  } else if (fileSize < (1024*1024*1024)) {
      temp = (fileSize / (1024*1024)).toFixed(2);
      return temp + 'M';
  } else {
      temp = (fileSize / (1024*1024*1024)).toFixed(2);
      return temp + 'G';
  }
}
let handleNumber = (numArr) =>{
  //自动转换数量
  if(numArr.length){
    let maxNum = numArr[0]
    numArr.forEach(item=>{
      if(item>maxNum) maxNum = item
    })
    if(maxNum>10000){
      let _numArr = numArr.map(item=>(item/10000).toFixed(2))
      return {numArr:_numArr,tag:'W'}
    } else{
      return {numArr,tag:''}
    }
    
  }else{
    return {numArr,hasHandled:''}
  }
}
let accMul = (arg1, arg2) => {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {}
  try {
    m += s2.split(".")[1].length
  } catch (e) {}
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
};

let accDiv = (arg1, arg2) => {
  var t1 = 0,
    t2 = 0,
    r1, r2, n;
  try {
    t1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    t1 = 0;
  }
  try {
    t2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    t2 = 0;
  }

  r1 = Number(arg1.toString().replace(".", ""));
  r2 = Number(arg2.toString().replace(".", ""));
  n = Math.max(t1, t2);
  return (r1 / r2) * Math.pow(10, t2 - t1);
}
export default {
  getQueryString,
  FormatDate,
  mapObj,
  getUrlKey,
  IdentityCodeValid,
  validatemobile,
  uniqueByKey,
  concatUrl,
  compare,
  autoSplit,
  number2Chinese,
  handelWeek,
  type,
  getFileType,
  getFileSize,
  handleNumber,
  accMul,
  accDiv
}
